// eslint-disable-next-line no-restricted-imports
import { create } from 'zustand';

import { registerStore } from './registry';
import { NonPersistentStoreInstance, StateCreator, StoreType } from './types';

export const LISTENING_SCREEN_STORES: NonPersistentStoreInstance<unknown>[] = [];

export function createNonPersistentStore<T>(
  initialState: StateCreator<T>,
  {
    isListeningScreenStore
  }: {
    isListeningScreenStore: boolean;
  }
) {
  const store = create(initialState);

  const useStore = <U>(selector: (state: T) => U) => {
    return store(selector ?? (state => state));
  };

  let cleanupFunctions: (() => void)[] = [];
  const registerOnResetCleanup = (fn: () => void) => {
    cleanupFunctions.push(fn);
  };

  const reset = () => {
    cleanupFunctions.forEach(fn => fn());
    store.setState(initialState, true);
    cleanupFunctions = [];
  };

  Object.assign(useStore, { ...store, reset, registerOnResetCleanup, type: StoreType.nonPersistent });

  const finalStore = useStore as NonPersistentStoreInstance<T>;

  if (isListeningScreenStore) {
    LISTENING_SCREEN_STORES.push(finalStore);
  }

  registerStore(finalStore);

  return finalStore;
}
